import { CrudFilters } from '@refinedev/core';

interface ICommonAcademicFilterParams {
  by_course_enrollment_type?: string;
  by_course_id?: string[];
  by_academic_status?: string | string[];
  by_user_name?: string;
  by_user_email?: string;
}

export const normalizeFilterText = (value?: string) =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined;

export const normalizeFilterValues = (value?: string | string[]) => {
  if (Array.isArray(value)) {
    const values = value.map(item => item.trim()).filter(Boolean);
    return values.length > 0 ? values : undefined;
  }

  return normalizeFilterText(value);
};

const academicStatusFilter = (value?: string | string[]) => {
  const normalized = normalizeFilterValues(value);
  const isList = Array.isArray(normalized);

  return {
    field: isList
      ? 'filter[by_academic_status][]'
      : 'filter[by_academic_status]',
    operator: isList ? ('in' as const) : ('eq' as const),
    value: normalized
  };
};

export const validateEnrollmentTypeSelection = (
  selectedValue: string | undefined,
  onInvalid: () => void
) => {
  if (!selectedValue) {
    onInvalid();
    return false;
  }

  return true;
};

export const buildCommonAcademicSearchFilters = (
  params: ICommonAcademicFilterParams
): CrudFilters => [
  {
    field: 'filter[by_course_enrollment_type]',
    operator: 'eq',
    value: params.by_course_enrollment_type
  },
  {
    field: 'filter[by_course_id][]',
    operator: 'in',
    value: params.by_course_id
  },
  academicStatusFilter(params.by_academic_status),
  {
    field: 'filter[by_user_name]',
    operator: 'eq',
    value: normalizeFilterText(params.by_user_name)
  },
  {
    field: 'filter[by_user_email]',
    operator: 'eq',
    value: normalizeFilterText(params.by_user_email)
  }
];

export const buildCommonAcademicExportFilters = <
  T extends ICommonAcademicFilterParams
>(
  formValues: T
) => ({
  ...formValues,
  by_academic_status: normalizeFilterValues(formValues.by_academic_status),
  by_user_name: normalizeFilterText(formValues.by_user_name),
  by_user_email: normalizeFilterText(formValues.by_user_email)
});
